let $ = require( "jquery" );

$(function() {

    let pagination = $('.pagination');

    if(pagination.length) {
        pagination.find('span').each(function () {

            if($(this).hasClass('prev')) {
                $(this).find('a').html('<span>‹</span>');
            } else if($(this).hasClass('next')) {
                $(this).find('a').html('<span>›</span>');
            }

        });
    }

});
